module.exports = __webpack_public_path__ + "static/media/who-sends-the-man.45ac4ce3.txt";